<template>
  <router-view />
</template>

<script>
export default {
  name: "InstrumentSingle"
};
</script>